import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { BondRequestDependenciesModel, BondRequestModel, BondRequestUpdateModel } from '@data-layer/models/common';
import { enumBondRequestState } from '@data-layer/enums/common';

@Injectable({
  providedIn: 'root',
})
export class BondRequestRepository {
  constructor(private apiService: ApiService) {}

  public create(companyId: number, bondRequest: BondRequestUpdateModel, isShowLoader: boolean = true): Observable<BondRequestModel> {
    return this.apiService.post(`${environment.url.companies}${companyId}/bond-request`, bondRequest, undefined, { isShowLoader });
  }

  public update(bondRequestId: number, bondRequest: BondRequestUpdateModel, isShowLoader: boolean = true): Observable<BondRequestModel> {
    return this.apiService.put(`${environment.url.prefixCustoms}v2/bond-requests/${bondRequestId}`, bondRequest, null, { isShowLoader });
  }

  public delete(bondRequestId: number, isShowLoader: boolean = true): Observable<never> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v2/bond-requests/${bondRequestId}`, null, { isShowLoader });
  }

  public sent(bondRequestId: number, isShowLoader: boolean = true): Observable<never> {
    return this.apiService.post(
      `${environment.url.prefixCustoms}v2/bond-requests/sent`,
      null,
      {
        params: { id: bondRequestId },
      },
      { isShowLoader },
    );
  }

  public dependencies(bondRequestId: number, isShowLoader: boolean = true): Observable<BondRequestDependenciesModel> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/bond-requests/${bondRequestId}/dependencies`, null, { isShowLoader });
  }

  public getState(id: number): Observable<enumBondRequestState> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/bond-requests/${id}/state`, null, { isShowLoader: false });
  }
}
